<br><br><br><br><br><br>
<div class="unsubscribe-card UnSubscrib_Card">

  <h2 class="title">{{ 'Unsubscribe' | translate }}</h2>

  <p class="message">
    {{ "We're sorry to see you go! Enter your email address to unsubscribe from this list." | translate }}
  </p>

  <h3 class="full-width" style="margin-bottom: 10px;">
    {{ 'Email Address' | translate }} <span class="required">*</span>
  </h3>

  <input type="email" [(ngModel)]="prObj.UnsubscribeReq.Email" required [placeholder]="'Enter your email' | translate"
    name="email" #emailField="ngModel" (blur)="checkEmailExists()" class="full-width unsubscribe-field"
    [disabled]="isUnsubmitting" />

  <div *ngIf="emailField.invalid && emailField.touched" class="error">
    {{ 'Email is required' | translate }}
  </div>

  <div *ngIf="emailChecked && prObj.UnsubscribeReq.Email" class="status-wrapper">
    <span *ngIf="emailExists" class="status-ok">&#10003;
      {{ 'Email found' | translate }}
    </span>
  </div>

  <h3 class="reason-title">
    {{ 'Reason for Unsubscribe' | translate }}
  </h3>

  <!-- Reason Dropdown -->
  <div class="full-width" style="margin-bottom: 10px;">
    <label for="unsubscribeReason">
      {{ 'Select Reason' | translate }}
    </label>
    <select id="unsubscribeReason" [(ngModel)]="prObj.UnsubscribeReq.UnsubscribeReasonCode"
      [disabled]="!emailExists || !emailEntered || disableReasonDropdown || isUnsubmitting" name="unsubscribeReason"
      class="left-align-panel full-width">

      <option *ngIf="disableReasonDropdown" disabled>
        {{ 'No reasons available' | translate }}
      </option>

      <option *ngFor="let r of bindObj.UnsubscribeList" [value]="r.code">
        {{ Language == 'en' ? (r.descEng | translate) : (r.descAr | translate) }}
      </option>
    </select>
  </div>

  <!-- Show reason input only if "Others" is selected -->
  <div *ngIf="prObj.UnsubscribeReq.UnsubscribeReasonCode == 5" style="margin-top: 10px;">
    <label class="input-heading">
      {{ 'Please enter reason' | translate }} <span class="required">*</span>
    </label>
    <input type="text" class="form-control" [(ngModel)]="prObj.UnsubscribeReq.OtherReason" [disabled]="isUnsubmitting"
      [placeholder]="'Enter your reason' | translate" />
  </div>

  <!-- Unsubscribe Button -->
  <div class="button-wrapper" style="margin-top: 12px;">
    <button (click)="onUnsubscribeClicked()" 
    [disabled]="isUnsubmitting || !prObj.UnsubscribeReq.Email || !emailExists"
      class="btn btn-primary" style="margin-right: 8px; background-color: rgb(44 55 144);">
      {{ 'Unsubscribe' | translate }}
    </button>
  </div>

  <!-- OTP section -->
  <div *ngIf="showOtpSection" style="margin-top: 20px;">
    <h3 class="input-heading">
      {{ 'Enter OTP' | translate }}<span class="required">*</span>
    </h3>

   <div class="form-group full-width" [dir]="currentLang === 'ar' ? 'rtl' : 'ltr'">
      <input type="text" inputmode="numeric" pattern="[0-9]*" [(ngModel)]="enteredOtp"
        [placeholder]="'Enter OTP' | translate" class="form-control otp-input" autocomplete="one-time-code"
        maxlength="6" (keypress)="allowOnlyNumbers($event)" />
    </div>  
     

    <div class="button-wrapper" style="margin-top: 12px;">
      <button (click)="VerifyOTP()" [disabled]="!enteredOtp || otpVerified" class="btn btn-primary"
        style="margin-right: 8px; background-color: rgb(44 55 144);">
        {{ 'Verify OTP' | translate }}
      </button>

      <button (click)="ResendOTP()" class="btn btn-primary"
        style="margin-right: 8px; background-color: rgb(44 55 144);">
        {{ 'Resend OTP' | translate }}
      </button>
    </div>
  </div>

</div>


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/Unsubscribe/Unsubscribe.html